// 拓尔思流式接口返回数据示例
// 已连接到 http://ai.trs.cn/agent-demo/agent/stream/impl
// MSG{"type": "log", "value": "开始执行：向量检索"}
// MSG{"type": "log", "value": "向量检索执行完成"}
// MSG{
//     "type": "link",
//     "value": [
//         {
//             "linkId": 1,
//             "docTitle": "最高涨80%！各省电价调整汇总！",
//             "docContent": "据了解，天津电价上浮并不是个例，为落实发改委要求，近期江苏、浙江、山东、广西等多地上调了上网电价，部分地区电价"顶格上浮"(上下浮动范围不超过20%)，内蒙古地区市场交易电价甚至上浮80%，浙江对高耗能用户征收惩罚性电费最高3毛5。实际上，8、9月份就有部分地区出台电价改革方案，例如贵州、广东等省份先后发布通知，执行分时电价政策，在平段电价基础上，上、下浮一定比例，形成高峰电价和低谷电价。目前限电最严的地区是河南，目前电炉已全部停产，长流程限产30%;长三角地区电力缺口仍有，但10月电炉厂并未大面积停产，以错峰生产为主。新疆维吾尔自治区发展和改革委员会发布了关于公开征求《关于完善我区分时电价机制有关事项的通知》意见的公告，尖峰时段用电价格在峰段电价基础上每千瓦时上浮20%。"管住中间、放开两头"，10月15日，新一轮电价改革开启。电价改革首日，山东、江苏等地电力市场成交价均较基准价有所上浮，基本触及此轮电价改革要求的上限，浙江、广西等多地也有所动作。日前，广东省发改委印发(粤发改价格[2021)402号)出台，从此，广东电力交易将发生根本变化，所有工商业用电都进入市场了，没有工商业目录电价电价可能涨幅将接近20%!最高涨80%！各省电价调整汇总！山东电力交易中心组织开展了深化煤电上网电价市场化改革后的首次交易，共有49家燃煤发电企业(97台机组)与79家售电公司和5家电力用户参与，成交电量110.7亿千瓦时，成交均价较基准电价上浮19.8%。浙江省发展改革委印发《关于进一步完善我省分时电价政策有关事项的通知》，此次调整延长了用电尖峰时段，并拉大了峰谷分时电价的价差。此次将全年大工业电价尖峰时段由原来的2个小时增加至4小时，每年夏季7、8月份及冬季1、12月份，全天尖峰时段由原来的2个小时增加至6小时，提高大工业尖峰电价每千瓦时5.6分、高峰电价每千瓦时6分。江苏组织开展了10月中旬月内挂牌交易，共成交电量19.98亿千瓦时，成交均价468.97元/兆瓦时，成交价较基准价上浮了19.94%。延长用电尖峰时段，拉大峰谷分时电价价差，对高耗能征收惩罚性电费，最高3毛5",
//             "date": "2021",
//             "url": "http://www.chinapower.com.cn/zhengcefagui/zhengcewenjian/2021-10-25/109718.html",
//             "dbname": "ny_zhengce"
//         },
//         {
//             "linkId": 2,
//             "docTitle": "美国得州大停电是"人祸"，别想让光伏风电背锅！",
//             "docContent": "在供需的极端不平衡下，得州电价疯狂飙升，最高时暴涨近200倍，批发电价突破了每兆瓦时1万美元，相当于每度电65元人民币，一些居民因此收到了供电公司的天价账单，停电的家庭和商户一度超过450万户，并有超过1490万人断水。",
//             "date": "2021",
//             "url": "http://www.chinapower.com.cn/xw/zyxw/20210222/53424.html",
//             "dbname": "ny_zhengce"
//         }
//     ]
// }
// MSG{"type": "log", "value": "输出节点"}
// MSG{"type": "log", "value": "开始思考"}
// MSG{"type": "think", "value": "\n"}
// MSG{"type": "think", "value": "好的"}
// MSG{"type": "think", "value": "，"}
// MSG{"type": "think", "value": "早上好"}
// ......
// MSG{"type": "log", "value": "思考结束"}
// MSG{"type": "llm", "value": "\n\n"}
// MSG{"type": "llm", "value": "根据"}
// MSG{"type": "llm", "value": "提供的"}
// MSG{"type": "llm", "value": "参考"}
// MSG{"type": "llm", "value": "文献"}
// ......
// MSG{"type": "llm", "value": "。"}
// COMPLETE{"type": "complete"}
// 已断开连接 http://ai.trs.cn/agent-demo/agent/stream/impl

// //接口调用方法
// const formData = new FormData()
// formData.append('text', msg.send)  // 发送的文本
// formData.append('sessionId', session_id)  // 会话ID,自己创建，用uuid生成
// formData.append('id', 201)  // 模型ID，固定  
// const apiUrl = 'http://ai.trs.cn/agent-demo/agent/stream/impl'

// fetch(apiUrl, {
//     method: 'POST',
//     body: formData,
//     signal: abortController.signal // Add abort signal
// })

import { useEffect, useState, useRef } from 'react';
import ReactMde from "react-mde";
import "react-mde/lib/styles/css/react-mde-all.css";
import * as Showdown from "showdown";
import { ReactComponent as SparkSvg } from '@images/icons/spark.svg';
import { ChevronDown, ChevronUp, ExternalLink, Calendar } from 'react-feather';
import { getPolicyChange } from '../../../../axios/api';

export const PolicyChangeAnalysis = (props) => {
    const { searchK } = props;
    
    // 状态管理
    const [isLoading, setIsLoading] = useState(false);
    const [isExpanded, setIsExpanded] = useState(true);
    const [isThinkExpanded, setIsThinkExpanded] = useState(true);
    const [currentStage, setCurrentStage] = useState('');
    const [thinkContent, setThinkContent] = useState('');
    const [answerContent, setAnswerContent] = useState('');
    const [links, setLinks] = useState([]);
    const [isComplete, setIsComplete] = useState(false);
    
    // refs
    const abortControllerRef = useRef(null);
    const sessionIdRef = useRef(null);
    
    // Showdown converter for markdown
    const converter = new Showdown.Converter({
        tables: true,
        simplifiedAutoLink: true,
        strikethrough: true,
        tasklists: true
    });

    // 生成会话ID
    const generateSessionId = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };

    // 重置状态
    const resetState = () => {
        setCurrentStage('');
        setThinkContent('');
        setAnswerContent('');
        setLinks([]);
        setIsComplete(false);
        setIsLoading(false);
    };

    // 处理流式数据
    const handleStreamData = (data) => {
        // console.log('收到流式数据:', data); // 添加调试日志
        try {
            const parsed = JSON.parse(data);
            // console.log('解析后的数据:', parsed); // 添加调试日志
            
            switch (parsed.type) {
                case 'log':
                    // console.log('处理log:', parsed.value);
                    setCurrentStage(parsed.value);
                    break;
                    
                case 'link':
                    // console.log('处理link:', parsed.value);
                    setLinks(parsed.value || []);
                    break;
                    
                case 'think':
                    // console.log('处理think:', parsed.value);
                    setThinkContent(prev => prev + parsed.value);
                    break;
                    
                case 'llm':
                    // console.log('处理llm:', parsed.value);
                    setAnswerContent(prev => {
                        let newContent = prev + parsed.value;
                        // 处理markdown表格格式
                        if (newContent.includes('|')) {
                            newContent = newContent.replace(/```markdown\|/g, '```markdown\n|');
                            newContent = newContent.replace(/\|\n```/g, '\n```');
                        }
                        if (newContent.includes('```markdown')) {
                            newContent = newContent.replace(/```markdown\n?/g, '');
                            newContent = newContent.replace(/\n?```/g, '');
                        }
                        // console.log('更新后的答案内容:', newContent);
                        return newContent;
                    });
                    break;
                    
                case 'complete':
                    // console.log('处理complete');
                    setIsComplete(true);
                    setIsLoading(false);
                    setCurrentStage('分析完成');
                    break;
                    
                default:
                    // console.log('未知类型:', parsed.type);
                    break;
            }
        } catch (error) {
            console.error('解析流式数据错误:', error, '原始数据:', data);
        }
    };

    // 调用政策变迁分析API
    const callPolicyChangeAPI = async (searchText) => {
        if (!searchText?.trim()) return;
        
        console.log('开始调用政策变迁接口，搜索内容:', searchText);
        resetState();
        setIsLoading(true);
        
        // 中止之前的请求
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
        
        abortControllerRef.current = new AbortController();
        sessionIdRef.current = generateSessionId();
        
        try {
            // 模拟流式处理的阶段
            setCurrentStage('开始执行：政策变迁分析');
            
            const requestData = {
                messages: [{
                    role: "user",
                    content: `请基于（${searchText}），生成一份结构清晰的政策变迁分析报告，首先概述该政策领域的背景及其重要性，然后分阶段梳理政策演变历程并对比各阶段特点，接着从经济、社会、技术等维度分析驱动因素，进行中外政策比较（可选），最后预测未来可能的发展方向及影响。要求所有分析均需引用权威政策文件或数据作为支撑，关键政策需注明具体条款，输出内容应客观严谨、具有时效性。`
                }],
                stream: true
            };
             // 如果是grid-build环境，添加model字段
            if (process.env.REACT_APP_TYPE === 'grid-build') {
                requestData.model = "DeepSeek-R1-Distill-Llama-70B-fast";
            }
            console.log('发送请求参数:', requestData);
            
            // 使用新的流式接口
            setCurrentStage(process.env.REACT_APP_CLIENT_ID === 'client-a' ? '接收流式响应...(由拓尔思提供支持)' : '接收流式响应...');

            await getPolicyChange(requestData, (progress) => {
                handleStreamData(JSON.stringify(progress));
            });
            
        } catch (error) {
            if (error.name === 'AbortError') {
                console.log('请求被中止');
            } else {
                console.error('政策变迁接口调用错误:', error);
                
                // 当接口调用失败时，使用静态数据
                const staticContent = `### 能源电力政策变迁分析报告

#### 一、背景及重要性

在当前全球化的背景下，能源电力产业不仅是国民经济的重要组成部分之一，也是国家综合国力和国际竞争力的关键体现。

#### 二、政策演变历程及特点

1. **初始阶段（20世纪80年代-90年代初）**：改革开放初期，为解决电力短缺问题，中央政府出台了一系列鼓励投资建设和扩大产能的措施，《中华人民共和国电力法》（1995年颁布）为我国电力工业的发展提供了法律保障。
   
2. **发展阶段（20世纪90年代中后期-21世纪初）**：随着《节约能源法》（1997年）、《可再生能源法》（2005年）等法律法规相继出台，标志着我国开始重视节能减排和新能源开发。同时，电力体制改革逐步深入，"厂网分开"、"竞价上网"等市场化改革措施得到有效推行，促进了市场竞争机制形成，提高了资源配置效率。
   
3. **转型期（2010年以来至今）**：
   - **"十二五"规划期间**（2011-2015年），明确提出要加快构建清洁低碳、安全高效的现代能源体系，《能源发展"十二五"规划》指出，"到2015年，非化石能源消费比重达到11.4%，单位国内生产总值能耗比2010年下降16%。"
   - **"十三五"规划期间**（2016-2020年），进一步强调绿色发展，《中共中央关于制定国民经济和社会发展第十三个五年规划的建议》提出，"加快推进能源生产和消费革命，建设清洁低碳、安全高效的现代化能源体系。"
   - **"十四五"规划及2035远景目标纲要**则将碳达峰、碳中和纳入生态文明建设整体布局，这表明我国将在未来一段时间内继续加大对于新能源领域投入力度，优化调整能源供给结构。

#### 三、驱动因素分析

1. **经济方面**：中国经济持续快速增长对能源需求量巨大，而传统化石燃料资源有限且环境污染严重，因此迫切需要寻找替代能源以满足社会发展的需要；同时，随着居民生活水平提升，民众对高品质生活的追求也促使了清洁能源的普及应用。
2. **社会方面**：公众环保意识增强，要求政府采取有效行动应对气候变化，减少污染物排放，保护生态环境；
3. **技术方面**：技术创新是推动能源转型的核心动力。近年来，风能、太阳能发电成本大幅下降，储能技术和智能电网建设取得突破，极大地促进了新能源产业发展。

#### 四、中外政策比较（以德国为例）

德国有着较为成熟的能源转型经验——"Energiewende"。

#### 五、未来发展展望

预计在未来几年乃至几十年里，中国将继续深化能源电力行业改革，重点推进以下几个方面：

1. 加快清洁能源项目建设，提高非化石能源消费比例；
2. 深入实施电能替代工程，推动终端用能电气化进程；
3. 完善电力交易规则，培育和发展多元化市场主体；
4. 强化科技创新支持，提升核心竞争力和自主创新能力；
5. 构建开放合作格局，积极参与全球能源治理体系重构。

这些举措有助于进一步巩固我国在全球能源治理中的地位，助力实现美丽中国愿景。

本报告基于现有资料编制，部分内容引用自《中华人民共和国电力法》(1995)、《中华人民共和国节约能源法》(1997)、《中华人民共和国可再生能源法》(2005)、《能源发展"十二五"规划》(2012)、《中共中央关于制定国民经济和社会发展第十三个五年规划的建议》(2015)等相关政策文件。`;
                
                // 使用静态数据模拟流式输出
                setCurrentStage('生成分析报告中...');
                const staticLines = staticContent.split('\n');
                for (let lineIndex = 0; lineIndex < staticLines.length; lineIndex++) {
                    const line = staticLines[lineIndex];
                    // 输出整行内容
                    handleStreamData(JSON.stringify({
                        type: 'llm',
                        value: line
                    }));
                    // 如果不是最后一行，添加换行
                    if (lineIndex < staticLines.length - 1) {
                        handleStreamData(JSON.stringify({
                            type: 'llm',
                            value: '\n'
                        }));
                    }
                    await new Promise(resolve => setTimeout(resolve, 50)); // 每行暂停
                }
                
                // 完成处理
                handleStreamData(JSON.stringify({
                    type: 'complete'
                }));
                
                setCurrentStage('分析完成');
            }
        } finally {
            setIsLoading(false);
        }
    };

    // 解析SSE事件
    const parseSSEEvent = (eventText) => {
        const lines = eventText.split('\n');
        let eventType = '';
        let data = '';
        
        for (const line of lines) {
            if (line.startsWith('event:')) {
                eventType = line.substring(6).trim();
            } else if (line.startsWith('data:')) {
                data = line.substring(5).trim();
            }
        }
        
        // console.log('解析SSE事件 - 类型:', eventType, '数据:', data);
        
        if (eventType === 'MSG' && data) {
            handleStreamData(data);
        } else if (eventType === 'COMPLETE' && data) {
            handleStreamData(data);
        }
    };

    // 监听搜索关键词变化
    useEffect(() => {
        if (searchK) {
            // 首先尝试调用真实的API接口
            callPolicyChangeAPI(searchK);
        }
        
        // 清理函数
        return () => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
        };
    }, [searchK]);

    // 获取预览内容（前三行）
    const getPreviewContent = () => {
        if (!answerContent) return '';
        const lines = answerContent.split('\n').filter(line => line.trim());
        return lines.slice(0, 3).join('\n');
    };

    return (
        <div className="w-full bg-base-100 mb-2 shadow pt-6 px-8 pb-0 border border-blue-200">
            <div className='flex w-full items-center gap-4 mb-6'>
                <SparkSvg/>
                <div className="card-title">
                    【{searchK}】相关政策变迁分析
                </div>
                {/* {searchK && (
                    <div className="badge badge-outline">
                        {searchK}
                    </div>
                )} */}
                {/* 当前阶段显示 */}
                {currentStage && (
                    <div className="">
                        <div className="flex items-center gap-2">
                            {isLoading && (
                                <span className="loading loading-spinner loading-sm"></span>
                            )}
                            <span className="text-sm text-base-content/70">
                                {currentStage}
                            </span>
                        </div>
                    </div>
                )}
            </div>
            
            {/* 思考内容和答案内容区域 */}
            {(thinkContent || answerContent || (isComplete && links.length > 0)) && (
                <div className="mb-4">
                    <div className="relative">
                        {/* 预览模式 */}
                        {!isExpanded && (
                            <div className="relative">
                                <div className="max-h-36 overflow-hidden">
                                    {/* 深度思考内容 */}
                                    {thinkContent && (
                                        <div className="mb-3">
                                            <div 
                                                className="flex items-center gap-2 cursor-pointer hover:text-primary transition-colors mb-2"
                                                onClick={() => setIsThinkExpanded(!isThinkExpanded)}
                                            >
                                                <span className="text-sm font-medium">深度思考</span>
                                                {isThinkExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                                            </div>
                                            
                                            {isThinkExpanded && (
                                                <div className="p-3 bg-base-200 rounded-lg text-sm">
                                                    <pre className="whitespace-pre-wrap font-sans text-base-content/70">
                                                        {thinkContent}
                                                    </pre>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    
                                    {/* 答案内容 */}
                                    {answerContent && (
                                        <div>
                                            <ReactMde
                                                selectedTab="preview"
                                                value={getPreviewContent()}
                                                readOnly
                                                generateMarkdownPreview={markdown =>
                                                    Promise.resolve(converter.makeHtml(markdown))
                                                }
                                            />
                                        </div>
                                    )}
                                </div>
                                {/* 渐变遮罩 */}
                                <div className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-base-100 to-transparent"></div>
                            </div>
                        )}
                        
                        {/* 完整内容模式 */}
                        {isExpanded && (
                            <div 
                                className="max-h-96 overflow-y-auto pr-2" 
                                style={{
                                    scrollbarWidth: 'thin', 
                                    scrollbarColor: 'hsl(var(--bc) / 0.3) transparent',
                                    WebkitScrollbarWidth: '8px',
                                    WebkitScrollbarTrack: 'transparent',
                                    WebkitScrollbarThumb: 'hsl(var(--bc) / 0.3)',
                                    WebkitScrollbarThumbBorderRadius: '4px'
                                }}
                            >
                                {/* 深度思考内容 */}
                                {thinkContent && (
                                    <div className="mb-4">
                                        <div 
                                            className="flex items-center gap-2 cursor-pointer hover:text-primary transition-colors mb-2"
                                            onClick={() => setIsThinkExpanded(!isThinkExpanded)}
                                        >
                                            <span className="text-sm font-medium">深度思考</span>
                                            {isThinkExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                                        </div>
                                        
                                        {isThinkExpanded && (
                                            <div className="p-3 bg-base-200 rounded-lg text-sm">
                                                <pre className="whitespace-pre-wrap font-sans">
                                                    {thinkContent}
                                                </pre>
                                            </div>
                                        )}
                                    </div>
                                )}
                                
                                {/* 答案内容 */}
                                {answerContent && (
                                    <div>
                                        <ReactMde
                                            selectedTab="preview"
                                            value={answerContent}
                                            readOnly
                                            generateMarkdownPreview={markdown =>
                                                Promise.resolve(converter.makeHtml(markdown))
                                            }
                                        />
                                    </div>
                                )}
                                
                                {/* 参考文献区域 */}
                                {/* {isComplete && links.length > 0 && (
                                    <div className="mt-6">
                                        <div className="divider divider-start">参考文献</div>
                                        <div className="space-y-3">
                                            {links.map((link, index) => (
                                                <div key={link.linkId || index} className="card bg-base-200 p-4">
                                                    <div className="flex items-start gap-3">
                                                        <div className="badge badge-primary badge-sm mt-1">
                                                            {index + 1}
                                                        </div>
                                                        <div className="flex-1">
                                                            <h4 className="font-medium text-base mb-2 hover:text-primary cursor-pointer">
                                                                {link.docTitle}
                                                            </h4>
                                                            <p className="text-sm text-base-content/70 mb-3 line-clamp-3">
                                                                {link.docContent}
                                                            </p>
                                                            <div className="flex items-center gap-4 text-xs text-base-content/60">
                                                                {link.date && (
                                                                    <div className="flex items-center gap-1">
                                                                        <Calendar size={12} />
                                                                        <span>{link.date}</span>
                                                                    </div>
                                )}
                                                                {link.url && (
                                                                    <a 
                                                                        href={link.url} 
                                                                        target="_blank" 
                                                                        rel="noopener noreferrer"
                                                                        className="flex items-center gap-1 hover:text-primary transition-colors"
                                                                    >
                                                                        <ExternalLink size={12} />
                                                                        <span>查看原文</span>
                                                                    </a>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )} */}
                                
                                {/* Add bottom padding for scroll bar space */}
                                <div className="pb-4"></div>
                            </div>
                        )}
                        

                    </div>
                </div>
            )}
            
            {/* 无内容提示 */}
            {!isLoading && !answerContent && !currentStage && (
                <div className="text-center text-base-content/50 py-8">
                    <p>请输入搜索关键词以开始政策变迁分析</p>
                </div>
            )}
        </div>
    );
};